<template>
  <router-view />
</template>

<script type="ts">
import Vue from 'vue';
import '@/styles/global';

export default Vue.extend({
  name: 'App',
  components: {},
});
</script>
